export default __webpack_public_path__ + "static/bg-ai-as-a-service--mobile-f7e0a6f85f388eae9270c96d897ec00f.webp";